import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll to the top of the page on every route change */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
